import React, { useState, useEffect } from "react";
import { Autocomplete, TextField, Box, IconButton } from "@mui/material";
import CachedIcon from "@mui/icons-material/Cached";
import LinkIcon from "@mui/icons-material/Link";
import { UseProductTaste } from "./UseProductTaste";

export default function TasteAutoComplete(props) {
  const { getAllTasteList } = UseProductTaste();
  const [productTasteRes, setProductTasteRes] = React.useState();
  const [selectedTaste, setSelectedTaste] = React.useState();

  useEffect(() => {
    getAllTasteList((tastes) => {
      setProductTasteRes(tastes);
    });
  }, []);

  useEffect(() => {
    if (productTasteRes && props.selectedTasteID) {
      setSelectedTaste(
        productTasteRes.tastes.find((m) => m.id == props.selectedTasteID)
      );
    }
  }, [productTasteRes, props.selectedTasteID]);

  useEffect(() => {
    if (selectedTaste) {
      props.setter({
        ...props.lvl2State,
        tasteID: selectedTaste.id,
      });
    }
  }, [selectedTaste]);

  return productTasteRes ? (
    <Box sx={{ display: "flex", alignItems: "center" }}>
      <Autocomplete
        disablePortal
        id="combo-box-demo"
        value={selectedTaste ? selectedTaste : ""}
        options={productTasteRes.tastes ? productTasteRes.tastes : []}
        getOptionLabel={(tastes) => (tastes.name ? tastes.name : "")}
        isOptionEqualToValue={(option, value) => option.value === value.value}
        renderInput={(params) => <TextField {...params} label="طعم" />}
        renderOption={(props, option) => {
          return (
            <li {...props} key={option.id}>
              {option.name ? option.name : ""}
            </li>
          );
        }}
        onChange={(evt, newValue) => {
          if (newValue) {
            setSelectedTaste(newValue);
          } else {
            setSelectedTaste();
            props.setter({
              ...props.lvl2State,
              tasteID: 0,
            });
          }
        }}
        fullWidth
        size="small"
      />
      <IconButton
        sx={{ p: 0, m: 1 }}
        onClick={() => {
          getAllTasteList((tastes) => {
            setProductTasteRes(tastes);
          });
        }}
      >
        <CachedIcon fontSize="small" />
      </IconButton>
      <IconButton sx={{ p: 0 }} href="/producttaste" target="_blank">
        <LinkIcon fontSize="small" />
      </IconButton>
    </Box>
  ) : (
    ""
  );
}
